const maybeDefault = (module: any) => {
  if (typeof module === 'object') {
    module = module.default;
  }

  return module;
};

export default maybeDefault;
